import styled from 'styled-components'
import tw from 'twin.macro'
import { CommunicationIcon } from 'components/Common/SvgIcons'
import TackleAvatarLogo from 'components/Common/TackleAvatarLogo'

export const StyledCommunicationIconWrapper = styled(CommunicationIcon)`
  ${tw`fill-purple w-6 h-6`}
`

export const MobileStyledCommunicationIconWrapper = styled(CommunicationIcon)`
  ${tw`h-[28px] w-[22px] fill-primary`}
`

export const TackleAvatarLogoWrapper = styled(TackleAvatarLogo)`
  ${tw`border-white outline-8 outline-offset-4 border-4 border-solid bg-blue-lighter1x h-full w-full rounded-full fill-white cursor-pointer sm:h-[80px] sm:w-[80px] md:w-[100px] md:h-[100px] xl:h-[120px] xl:w-[120px]`}
`

export const ActiveClientWrapper = styled.div`
  ${tw`relative px-5 pt-6 pb-6 block`}
`

export const CommunicationIconWrapper = styled.div`
  ${tw`absolute top-4 right-4 z-[10] cursor-pointer`}
`

export const ClientWrapper = styled.div`
  ${tw`flex items-center justify-center flex-col mb-5`}
`

export const LogoWrapper = styled.div`
  ${tw`relative h-[100px] w-[100px] mdl:h-[80px] mdl:w-[80px] xl:h-[120px] xl:w-[120px] flex items-center justify-center flex-shrink-0`}
`

export const NavigateToClientDetailWrapper = styled.div`
  ${tw`text-[#6C3EF2] font-bold mt-4 text-lg leading-5 cursor-pointer`}
`

export const BusinessInfoWrapper = styled.div`
  ${tw`flex justify-between items-center mb-2 gap-3`}
`

export const BusinessTextWrapper = styled.p`
  ${tw`text-sm font-normal text-silver`}
`

export const BusinessNameWrapper = styled.p`
  ${tw`text-base font-normal text-black-light line-clamp-1 text-right`}
`

export const MobileActiveClientWrapper = styled.div`
  ${tw`px-2 pt-[13.8px] pb-[13.8px]`}
`

export const MobileClientWrapper = styled.div`
  ${tw`flex pl-1 justify-between items-center`}
`

export const MobileClientInfoWrapper = styled.div`
  ${tw`inline-flex`}
`

export const MobileClientIconWrapper = styled.div`
  ${tw`relative h-[54px] w-[54px] flex items-center justify-center flex-shrink-0`}
`

export const MobileActiveClientCardWrapper = styled.div`
  ${tw`flex flex-col ml-4 inline-flex justify-center`}
`

export const MobileNavigateToClientDetailWrapper = styled.p`
  ${tw`text-primary font-primary text-lg font-semibold cursor-pointer`}
`

export const MobileBusinessNameWrapper = styled.p`
  ${tw`text-sm font-semibold text-zinc font-primary`}
`

export const CommunicationWrapper = styled.div`
  ${tw`flex flex-col mr-2`}
`

export const MobileCommunicationIconWrapper = styled.div`
  ${tw`flex justify-end cursor-pointer`}
`

export const LabelWrapper = styled.div`
  ${tw`text-xs flex justify-end`}
`
